import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { modal, content, close } from './styles.js';
import { IconButton } from '../IconButton/IconButton.web.js';
import { usePrevMounted } from '../utils/hooks/usePrevMounted.js';
import { Portal } from '../utils/components/Portal/Portal.web.js';
import { IconCross } from '../icons/ui_control/IconCross.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { Overlay } from '../utils/components/Overlay/Overlay.web.js';
import { TrapFocus } from '../utils/components/TrapFocus/TrapFocus.web.js';

var Modal = function Modal(_ref) {
  var _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
      style = _ref.style,
      children = _ref.children,
      fullScreen = _ref.fullScreen,
      opened = _ref.opened,
      onClose = _ref.onClose,
      preventClose = _ref.preventClose,
      container = _ref.container,
      variantProp = _ref.variant,
      props = _objectWithoutProperties(_ref, ["noPadding", "hideCloseButton", "style", "children", "fullScreen", "opened", "onClose", "preventClose", "container", "variant"]);

  var _usePrevMounted = usePrevMounted(),
      _usePrevMounted2 = _slicedToArray(_usePrevMounted, 1),
      prevMounted = _usePrevMounted2[0];

  var theme = useTheme();
  var variant = variantProp || theme.variant;
  var handleClose = React.useCallback(function () {
    if (onClose && !preventClose) {
      onClose();
    }
  }, [onClose, preventClose]);
  var animateIn = opened && prevMounted;
  return /*#__PURE__*/React.createElement(Portal, {
    container: container
  }, /*#__PURE__*/React.createElement(Overlay, {
    "data-test": "elemental-Modal",
    onClose: handleClose,
    opened: Boolean(opened),
    centered: true
  }, /*#__PURE__*/React.createElement(TrapFocus, {
    enabled: Boolean(opened)
  }, /*#__PURE__*/React.createElement(modal, _extends({
    animateIn: animateIn,
    fullScreen: fullScreen,
    "aria-modal": "true",
    role: "document",
    noPadding: noPadding,
    style: style,
    theme: theme
  }, props), /*#__PURE__*/React.createElement(content, {
    "data-test": "elemental-Modal-content",
    fullScreen: fullScreen,
    noPadding: noPadding,
    alignContent: props.alignContent,
    variant: variant
  }, children, !preventClose && !hideCloseButton ? /*#__PURE__*/React.createElement(close, {
    "aria-label": "close"
  }, /*#__PURE__*/React.createElement(IconButton, {
    "data-test": "elemental-Modal-close",
    color: theme.colors.background,
    status: "plain",
    invert: true,
    onClick: handleClose,
    icon: IconCross
  })) : null)))));
};

export { Modal };
